import './form-cta.css';
import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import axios from 'axios';
import '/src/i18n';
import store from './Redux/store';
import App from './App';
import { initializeFormSubmission } from './CheckFormHooks';
import { installAxiosCsrfInterceptor, resolveCsrfToken } from 'react_common/src/Util/csrfAjax';

installAxiosCsrfInterceptor(axios, () => resolveCsrfToken());

window.store = store;

const formRootElement = document.getElementById('form-inputs');
if (formRootElement && formRootElement.dataset.controller) {
	initializeFormSubmission(formRootElement.dataset.controller, formRootElement.dataset.funnel_page_id);
}

const mountedRoots = window.__xleadMountedReactRoots || (window.__xleadMountedReactRoots = new Map());

const renderComponent = (id, Component) => {
	const rootElement = document.getElementById(id);
	if (!rootElement) return;
	let mounted = mountedRoots.get(id);
	if (mounted && mounted.element !== rootElement) {
		try {
			mounted.root.unmount();
		} catch (_e) {}
		mounted = null;
		mountedRoots.delete(id);
	}
	if (!mounted) {
		mounted = {
			element: rootElement,
			root: createRoot(rootElement)
		};
		mountedRoots.set(id, mounted);
	}
	mounted.root.render(
		<Provider store={store}>
			<Component {...rootElement.dataset} />
		</Provider>
	);
};

renderComponent("form-inputs", App);
